import React, { Component } from 'react';
import Layout from '../../components/layout';
import { withTranslation } from '../../lib/translate';
import { connect } from 'react-redux';
import { getNotifications, readNotifications } from '../../store/actions';
import Loading from '../../components/spinner';
import './index.css';
import { NormalText, SmallText, Spacer, Subtitle, Title } from '../../components/common';
import moment from 'moment';
import { IonButton } from '@ionic/react';
import { forwardTo } from '../../lib/utils';

class Notification extends Component {

    componentDidMount() {
        const { notifications } = this.props;
        if (notifications.length === 0) {
            this.props.dispatch(getNotifications());
        }
        this.readNotification();
    }
    componentDidUpdate(prevProps) {
        if (this.getNotificationId(prevProps) !== this.getNotificationId()) {
            this.readNotificationId = null;
        }
        if (prevProps.notifications !== this.props.notifications && !this.getNotification().id) {
            forwardTo('/inbox');
            return;
        }
        this.readNotification();
    }
    getNotificationId(props = this.props) {
        return props.match?.params?.id;
    }
    readNotification() {
        const notificationId = this.getNotificationId();
        if (!notificationId || this.readNotificationId === notificationId || !this.getNotification().id) {
            return;
        }
        this.readNotificationId = notificationId;
        this.props.dispatch(readNotifications(notificationId));
    }
    getNotification() {
        const notificationId = this.getNotificationId();
        const { notifications } = this.props;
        return notifications.find((el) => `${el.id}` === `${notificationId}`) || {};
    }
    openCTALink(url) {
        if (url.includes('https://') || url.includes('http://')) {
            window.open(url)
        } else {
            forwardTo(url)
        }
    }
    render() {
        const { __ } = this.props;
        const notification = this.getNotification()
        return (
            <Loading>
                <Layout
                    backHandler={() => forwardTo('/inbox')}
                    hideSecondToolbar={true}
                    color="transparent"
                    headerTitle={__('Inbox')}


                >
                    <div className='scrollable-y absolute-content single-notification'>
                        {notification.show_image && notification.image &&
                            <img className='notification-cover-image' src={notification.image} />
                        }
                        <div className='notification-body'>
                            <Title>{notification.notification_title}</Title>
                            <Spacer size={1} />
                            <div></div>
                            <div className='notification-html-content' dangerouslySetInnerHTML={{ __html: notification.content_html }} ></div>
                            <Spacer size={2} />
                            {notification.show_cta &&
                                <IonButton onClick={() => this.openCTALink(notification.cta_url)} expand='block' color='primary'>{notification.cta_button_text}</IonButton>

                            }


                        </div>
                    </div>
                </Layout>
            </Loading>
        );
    }
}

const stateToProps = (state) => {
    return {
        notifications: state.profile.notifications || [],
    }
};
export default connect(stateToProps)(withTranslation(Notification));
